<div class="container-filter">
    <div class="filter-header" (click)="toggleExpand()">
        <h2>{{ filter.name | translate | uppercase }}
            <span
                    class="total-selected"
                    *ngIf="filter.totalSelected > 0 && !filter.isTextarea">({{ filter.totalSelected }})
            </span>
        </h2>
        <ion-icon color="medium" [ngClass]="{
            'bp-arrow-top': open,
            'bp-arrow-bottom': !open
          }" slot="end"></ion-icon>
    </div>
    <div class="filter-content" *ngIf="open">
        <ion-searchbar *ngIf="filter.hasSearch" mode="ios" class="section-search-custom"
                       [placeholder]="'filters.search' | translate"
                       (keyup)="updateSearch($event)">
        </ion-searchbar>
        <ion-searchbar *ngIf="filter.isTextarea" mode="ios" class="section-search-custom"
                       [placeholder]="'filters.search' | translate"
                       [value]="term"
                       (keyup)="setValue($event)">
        </ion-searchbar>
        <ng-container *ngFor="let item of filter.items; let i = index">
            <div class="container-date" *ngIf="filter.typeName === 'DateFilter'">
                <ion-label class="ion-text-wrap">{{ item.name | translate | uppercase }}</ion-label>
                <div>
                    <input type="date" [(ngModel)]="item.value" (ngModelChange)="dateChanged(i, $event)"/>
                </div>
            </div>
            <div class="container-item" *ngIf="filter.typeName !== 'DateFilter' && !filter.isTextarea" (click)="toggleSelectItem(i)">
                <ion-checkbox custom-checkbox slot="start" mode="ios" [checked]="item.selected"></ion-checkbox>
                <ion-label class="ion-text-wrap">{{ item.name | translate | uppercase }}</ion-label>
            </div>
        </ng-container>
    </div>
</div>


